module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpanded.ccdc7a3.woff";